function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Label from '../label/Label';
import Icon from '../icon/Icon';
import { BORDER_HIDDEN, BORDER_NONE, BORDER_SIMPLE, STYLE_BASIC, BORDER_TYPES_PROP_TYPES, STYLES_PROP_TYPES, MIN_ASIDE_SPACING_PROP_TYPES, MIN_ASIDE_SPACING_PREFIX, MIN_ASIDE_SPACING_BOTH, MIN_ASIDE_SPACING_SUFFIX } from './constants';
import { isStatic } from './utils';
/**
 * Helper component that conditionally renders an annotation note
 * @prop {string} annotationNote - string to be displayed in annotation
 */

var FieldAnnotation = function FieldAnnotation(_ref) {
  var annotationNote = _ref.annotationNote;
  var component = null;

  if (annotationNote) {
    component = React.createElement("aside", {
      className: "eds-field-styled__annotation eds-text-bs eds-fx--fade-in eds-l-pad-top-1",
      "data-automation": "eds-field-annotation",
      role: "alert"
    }, annotationNote);
  }

  return component;
};
/**
 * Helper component that conditionally renders a character counter
 * @prop {bool} hasCharacterCount - toggles the character counter
 * @prop {string} value - current value of the input field
 * @prop {integer} maxLength - maximum characters allowed in the input
 */


var CharacterCounter = function CharacterCounter(_ref2) {
  var hasCharacterCount = _ref2.hasCharacterCount,
      value = _ref2.value,
      maxLength = _ref2.maxLength;
  var component = null;

  if (hasCharacterCount) {
    var currentLength = value.length;
    component = React.createElement("aside", {
      className: "eds-field-styled__character-counter eds-text-bs eds-fx--fade-in eds-l-pad-top-1"
    }, "".concat(currentLength, "/").concat(maxLength));
  }

  return component;
};
/**
 * Helper component that conditionally renders a link
 * @prop {string} children - link to display
 */


var StyledLink = function StyledLink(_ref3) {
  var children = _ref3.children,
      href = _ref3.href;
  var component = null;

  if (children) {
    component = React.createElement("a", {
      className: "eds-field-styled__link eds-text-bs eds-fx--fade-in eds-l-pad-top-1",
      href: href
    }, children);
  }

  return component;
};
/**
 * Helper component that conditionally renders an inline node or text
 * @prop {node} prefix - element to be displayed to the left of the input
 * @prop {node} suffix - element to be displayed to the right of the input
 */


var AsideElement = function AsideElement(_ref4) {
  var suffix = _ref4.suffix,
      prefix = _ref4.prefix,
      hasMinAsideSpacing = _ref4.hasMinAsideSpacing;
  var component = null;
  var aside = prefix || suffix;
  var isIcon = aside && aside.type === Icon;
  var className = classNames('eds-field-styled__aside', {
    'eds-field-styled__aside-prefix': prefix,
    'eds-field-styled__aside-suffix': suffix,
    'eds-field-styled__aside--icon': isIcon,
    'eds-field-styled__aside--minimal-spacing': hasMinAsideSpacing
  });

  if (aside) {
    component = React.createElement("span", {
      className: className
    }, aside);
  }

  return component;
};
/**
 * Helper component that conditionally renders an inline node or text
 * @prop {annotationNote} FieldAnnotation - element to be displayed to the left of the input
 * @prop {linkSrc} StyledLink - element to be displayed to the right of the input
 * @prop {linkText} StyledLink - element to be displayed to the right of the input
 * @prop {hasCharacterCount} CharacterCounter - element to be displayed to the right of the input
 * @prop {value} CharacterCounter - element to be displayed to the right of the input
 * @prop {maxLength} CharacterCounter - element to be displayed to the right of the input
 */


var FieldSub = function FieldSub(_ref5) {
  var annotationNote = _ref5.annotationNote,
      linkSrc = _ref5.linkSrc,
      linkText = _ref5.linkText,
      hasCharacterCount = _ref5.hasCharacterCount,
      value = _ref5.value,
      maxLength = _ref5.maxLength;
  var fieldSub = null;
  var fieldSubLeft = null;
  var fieldSubRight = null;

  if (annotationNote) {
    fieldSubLeft = React.createElement("div", {
      className: "eds-field__sub--left"
    }, React.createElement(FieldAnnotation, {
      annotationNote: annotationNote
    }));
  }

  if (linkSrc && linkText || hasCharacterCount) {
    fieldSubRight = React.createElement("div", {
      className: "eds-field__sub--right"
    }, React.createElement(StyledLink, {
      href: linkSrc
    }, linkText), React.createElement(CharacterCounter, {
      hasCharacterCount: hasCharacterCount,
      value: value,
      maxLength: maxLength
    }));
  }

  if (fieldSubLeft || fieldSubRight) {
    fieldSub = React.createElement("div", {
      className: "eds-field__sub"
    }, fieldSubLeft, fieldSubRight);
  }

  return fieldSub;
};

var FieldWrapper =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(FieldWrapper, _PureComponent);

  function FieldWrapper() {
    _classCallCheck(this, FieldWrapper);

    return _possibleConstructorReturn(this, _getPrototypeOf(FieldWrapper).apply(this, arguments));
  }

  _createClass(FieldWrapper, [{
    key: "_handleMouseDown",
    value: function _handleMouseDown(e) {
      e.preventDefault();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          annotationNote = _this$props.annotationNote,
          bottomSpacing = _this$props.bottomSpacing,
          children = _this$props.children,
          dataSpec = _this$props.dataSpec,
          dataAutomation = _this$props.dataAutomation,
          disabled = _this$props.disabled,
          style = _this$props.style,
          borderType = _this$props.borderType,
          hasError = _this$props.hasError,
          id = _this$props.id,
          isActive = _this$props.isActive,
          isMultiline = _this$props.isMultiline,
          label = _this$props.label,
          required = _this$props.required,
          suffix = _this$props.suffix,
          prefix = _this$props.prefix,
          value = _this$props.value,
          hasMinAsideSpacing = _this$props.hasMinAsideSpacing,
          minAsideSpacing = _this$props.minAsideSpacing,
          maxLength = _this$props.maxLength,
          hasCharacterCount = _this$props.hasCharacterCount,
          linkText = _this$props.linkText,
          linkSrc = _this$props.linkSrc;
      var hasSimpleBorder = borderType === BORDER_SIMPLE;
      var isBorderless = borderType === BORDER_NONE;
      var isBorderHidden = borderType === BORDER_HIDDEN;
      var shouldHideLabel = style === STYLE_BASIC;
      var shouldShowAsStatic = isStatic({
        style: style,
        value: value,
        hasError: hasError,
        isActive: isActive
      });
      var containerClassName = classNames('eds-field-styled', "eds-l-mar-bot-".concat(bottomSpacing), {
        'eds-field-styled--disabled': disabled,
        'eds-field-styled--basic': shouldHideLabel,
        'eds-field-styled--static': shouldShowAsStatic,
        'eds-field-styled--focus': isActive && !hasSimpleBorder,
        'eds-field-styled--error': hasError,
        'eds-field-styled--borderless': isBorderless,
        'eds-field-styled--hidden-border': isBorderHidden
      });
      var borderSimulationClassName = classNames('eds-field-styled__border-simulation', {
        'eds-field-styled__border-simulation--simple': hasSimpleBorder,
        'eds-field-styled__border-simulation--empty': isBorderless
      });
      var inputContainerClassName = classNames('eds-field-styled__input-container', {
        'eds-field-styled__input-container--multiline': !shouldHideLabel && isMultiline && !disabled
      });
      var prefixHasMinAsideSpacing = hasMinAsideSpacing || minAsideSpacing === MIN_ASIDE_SPACING_PREFIX || minAsideSpacing === MIN_ASIDE_SPACING_BOTH;
      var suffixHasMinAsideSpacing = hasMinAsideSpacing || minAsideSpacing === MIN_ASIDE_SPACING_SUFFIX || minAsideSpacing === MIN_ASIDE_SPACING_BOTH;
      return React.createElement("div", {
        className: containerClassName,
        "data-automation": dataAutomation,
        "data-spec": dataSpec
      }, React.createElement("div", {
        className: borderSimulationClassName
      }, React.createElement("div", {
        className: "eds-field-styled__internal"
      }, React.createElement(AsideElement, {
        prefix: prefix,
        hasError: hasError,
        hasMinAsideSpacing: prefixHasMinAsideSpacing
      }), React.createElement("div", {
        className: inputContainerClassName
      }, React.createElement("div", {
        className: "eds-field-styled__label-wrapper"
      }, React.createElement(Label, {
        id: "".concat(id, "-label"),
        hidden: shouldHideLabel,
        htmlFor: id,
        required: required,
        onMouseDown: this._handleMouseDown.bind(this),
        shouldShowAsStatic: shouldShowAsStatic
      }, label)), children), React.createElement(AsideElement, {
        suffix: suffix,
        hasError: hasError,
        hasMinAsideSpacing: suffixHasMinAsideSpacing
      }))), React.createElement(FieldSub, {
        annotationNote: annotationNote,
        linkSrc: linkSrc,
        linkText: linkText,
        hasCharacterCount: hasCharacterCount,
        value: value,
        maxLength: maxLength
      }));
    }
  }]);

  return FieldWrapper;
}(PureComponent);

_defineProperty(FieldWrapper, "propTypes", {
  /**
   * The amount of spacing for the bottom
   */
  bottomSpacing: PropTypes.number.isRequired,

  /**
   * FieldWrapper should be provided with a single element.
   */
  children: PropTypes.element.isRequired,

  /**
   * Text to be displayed as the label of the input element.
   * Required for accessibility reasons but it can be hidden.
   */
  label: PropTypes.node.isRequired,

  /**
   * Text to be displayed as annotation below the input element.
   */
  annotationNote: PropTypes.node,

  /**
   * Sets disabled attribute to the input element.
   */
  disabled: PropTypes.bool,

  /**
   * Defines whether the field should hide or display an static or animated label.
   * By default it will display an animated label.
   */
  style: STYLES_PROP_TYPES,

  /**
   * Field border type chosen for the input. It can be one of: 'default', 'simple' or 'none'.
   * Default: the border changes from grey on idle to a coloured state on focus.
   * Simple: the border preserves its grey colour and has no rounded corners.
   * None: the border is hidden and is replaced by a line below the input to point the writtable area.
   */
  borderType: BORDER_TYPES_PROP_TYPES,

  /**
   * Sets error state (adds error classes and aria-invalid).
   */
  hasError: PropTypes.bool,

  /**
   * Sets the id for the input element and htmlFor attribute for the label.
   */
  id: PropTypes.string,

  /**
   * Changes the input field for a textarea
   */
  isMultiline: PropTypes.bool,

  /**
   * Marks the input as required (adds * and aria-required).
   */
  required: PropTypes.bool,

  /**
   * Sets the max length of the character counter and also limits the
   * number of characters you can input.
   */
  maxLength: PropTypes.number,

  /**
   * Toggles a display of the current character count against the maximum characters allowed in the field.
   */
  hasCharacterCount: PropTypes.bool,

  /**
   * Text for the link to display.
   */
  linkText: PropTypes.string,

  /**
   * Source url of the link to display.
   */
  linkSrc: PropTypes.string,

  /**
   * Node to be displayed to the left of the input
   */
  prefix: PropTypes.node,

  /**
   * Node to be displayed to the right of the input.
   */
  suffix: PropTypes.node,

  /**
   * Value of text input
   * The value can override the default value if specified
   * After the text input has been rendered the first time,
   * if the value changes, it *will* update the input.
   */
  value: PropTypes.string,

  /**
  * Active state of the input field
  */
  isActive: PropTypes.bool,

  /**
   * Needed for inputs that use an aside element (both prefix and suffix)
   * that is bigger than the normal text size. If the content (maybe a button or icon)
   * is getting cropped on the sides, this lowers the margin allowing it to
   * center within the aside again.
   *
   * NOTE: This property is deprecated in favor of minAsideSpacing.
   */
  hasMinAsideSpacing: PropTypes.bool,

  /**
   * Needed for inputs that use an aside element (either prefix, suffix or both)
   * that is bigger than the normal text size. If the content (maybe a button or icon)
   * is getting cropped on the sides, this lowers the margin allowing it to
   * center within the aside again.
   */
  minAsideSpacing: MIN_ASIDE_SPACING_PROP_TYPES,

  /**
   * Identifier for tests.
   */
  'dataSpec': PropTypes.string,

  /**
   * Automation identifier. We need a data-automation tag targeting field wrappers so we can associate
   * labels, fields, error messages, etc. without using markup-dependent sibling selectors
   */
  'dataAutomation': PropTypes.string
});

_defineProperty(FieldWrapper, "defaultProps", {
  'dataSpec': 'field-gradient' // We want to make sure the the label doesn't respond to mousedown events
  // In cases where the label is styled to overlap an input we essentially want to ignore
  // those events so they don't interfere with the underlapped element

});

export { FieldWrapper as default };